import React from 'react';

import VariantPendingQuantityInput from '../containers/VariantPendingQuantityInput';
import WrappedBase from './WrappedBase';

export default class ControlsStore extends React.Component {
  render() {
    return (
      <WrappedBase>
        <VariantPendingQuantityInput {...this.props} />
      </WrappedBase>
    );
  }
}
